import ReactGA from 'react-ga4';
import { numify } from 'numify';
import { useEffect } from 'react';
////////////////////////////////////////////////////////////////////
import {
	Carousel,
	CarouselContent,
	CarouselItem,
	CarouselNext,
	CarouselPrevious,
} from '@/app/shared/components';
import { useCustomSelector } from '@/core/redux/hooks';
import { Level } from '@/core/interfaces';

/**
 * LevelStandings component
 *
 * Shows the current level standings.
 *
 * @returns A JSX element representing the level standings.
 */
const LevelStandings: React.FC = () => {
	/*********************
	// #region Redux
	**********************/
	const { level, levelsRequeriments } = useCustomSelector(
		(state) => state.counter
	);

	/*********************
	// #region Observables
	**********************/
	useEffect(() => {
		ReactGA.send({
			hitType: 'pageview',
			page: '/levels',
			title: 'Levels',
		});
	}, []);

	/*********************
	// #region Template
	**********************/
	return (
		<div className="flex flex-col gap-2 pt-8 mx-4">
			<Carousel
				opts={{
					startIndex: level - 1,
				}}
			>
				<CarouselContent>
					{levelsRequeriments.map((level: Level) => {
						return (
							<CarouselItem key={level.name}>
								<div className="flex h-svh -mt-[85px] items-center flex-col justify-center">
									<img
										className={`px-16`}
										src={level.image}
										alt={level.name}
									/>
									<p className="text-center text-xl font-bold">
										{level.name}
									</p>

									{level.requiredPoints > 0 && (
										<p className="text-center text-xl font-bold text-white/60">
											({numify(level.requiredPoints)})
										</p>
									)}

									{/* {level.myPosition && (
									<div
										className={`flex mx-4 mt-6  py-4 rounded-2xl gap-1 items-center bg-level-gradient-${level.level}`}
										>
										<div className="flex flex-1 gap-2 items-center">
										<div className="flex gap-1 items-center">
										<p className="text-lg font-bold pl-4">
										{numify(
											level.myPosition
											.position
											)}
											</p>
											</div>
											<img
											className="max-w-[60px]"
											src={level.image}
											alt={level.name}
											/>

											<div className="flex flex-col">
											<p className="text-sm font-bold">
											{level.myPosition.username}
												</p>
												<div className="flex text-shadow-xs text-xs gap-2 items-center">
												{level.name}
												<div className="flex items-center">
												<img
												src={ShurikenImage}
												className="drop-shadow-lg w-[16px]"
												/>
														{numify(
															level.myPosition
																.gainsPerHour
																)}
																</div>
																</div>
																</div>
																</div>
																</div>
																)}
																
																<div className="flex flex-col gap-2 py-4">
																{level.standing.map(
																	(position: Standing) => {
																		return (
																			<div key={position.username}>
																			<div className="flex rounded-2xl gap-1 items-center bg-customer-900/70 px-2 option-menu-setting mx-4">
																			<div className="flex flex-1 gap-2 items-center">
																			<div className="flex gap-1 items-center">
																			<p className="text-lg font-bold pl-4 min-w-[40px]">
																			{numify(
																		position.position
																	)}
																	</p>
																	</div>
																	<img
																	className="max-w-[80px] p-2"
																	src={
																	level.image
																}
																alt={level.name}
															/>

															<div className="flex flex-col">
																<p className="text-sm font-bold">
																{
																	position.username
																	}
																	</p>
																	<div className="flex text-shadow-xs text-xs gap-2 items-center">
																	{level.name}
																	<div className="flex items-center">
																		<img
																			src={
																				ShurikenImage
																				}
																			className="drop-shadow-sm w-[16px]"
																		/>
																		{numify(
																			position.gainsPerHour
																			)}
																	</div>
																</div>
																</div>
														</div>
													</div>
												</div>
											);
										}
										)}
								</div> */}
								</div>
							</CarouselItem>
						);
					})}
				</CarouselContent>
				<CarouselPrevious className="left-0 z-20 top-2/4 ml-4" />
				<CarouselNext className="right-0 z-20 top-2/4 mr-4" />
			</Carousel>
		</div>
	);
};

export default LevelStandings;
